<template>
  <div id="login" class="container">

        <!-- Outer Row -->
        <div class="row justify-content-center">

            <div class="col-xl-10 col-lg-12 col-md-9">

                <div class="card o-hidden border-0 shadow-lg my-5">
                    <div class="card-body p-0">
                        <!-- Nested Row within Card Body -->
                        <div class="row">
                            <div class="col-lg-6 d-none d-lg-block bg-login-image" style="background-image:url(building.jpg);"></div>
                            <div class="col-lg-6">
                                <div class="p-5">
                                    <div class="text-center">
                                        <img style="width: 100px;" src="../assets/logo.png" />
                                        <h1 class="h4 text-gray-900 mb-2 mt-3">Cameroom</h1>
                                        <div class="text-gray-900 mb-4 mt-3" style="font-size:12px">เรียกดูกล้องไอพีในบ้านหรือบริษัทของคุณในที่เดียว</div>
                                    </div>
                                    <form class="user">
                                        <div class="form-group">
                                            <input type="email" class="form-control form-control-user"
                                                id="exampleInputEmail" v-model="username" aria-describedby="emailHelp"
                                                placeholder="เบอร์โทร...">
                                        </div>
                                        <div class="form-group">
                                            <input type="password" class="form-control form-control-user"
                                                id="exampleInputPassword" v-model="password" placeholder="รหัสผ่าน..." v-on:keyup.enter="makeLogin()" >
                                        </div>
                                        <!-- <div class="form-group">
                                            <div class="custom-control custom-checkbox small">
                                                <input type="checkbox" class="custom-control-input" id="customCheck">
                                                <label class="custom-control-label" for="customCheck">
                                                    จดจำฉัน
                                                </label>
                                            </div>
                                        </div> -->
                                        <button type="button" v-on:click="makeLogin()" class="btn btn-primary btn-user btn-block">
                                            เข้าสู่ระบบ
                                        </button>
                                    </form>
                                    <hr>
                                    <div class="text-center">
                                        <router-link class="small" to="forgot-password">ลืมรหัสผ่านใช่หรือไม่ ?</router-link>
                                    </div>
                                    <div class="text-center">
                                        <a class="small" href="https://cameroom.net/register/"><i class="fas fa-registered fa-fw"></i>&nbsp;สมัครเป็นผู้ใช้งาน</a>
                                    </div>
                                    <div class="text-center">
                                        <a class="small" href="https://cameroom.net/"><i class="fas fa-video fa-fw"></i>&nbsp;กลับไปที่ cameroom.net</a>
                                    </div>
                                    <!-- <div class="text-center">
                                        <router-link class="small" to="register"><i class="fas fa-registered  fa-fw"></i>&nbsp;สมัครเป็นผู้ใช้งาน</router-link>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

  </div>

</template>


<script>
import { AuthService } from '@/services/auth.service'
import { AlertService } from '@/services/alert.service'
 
export default {
    name : "Login",
    data() {
        return {
            username : '',
            password : ''
        }
    },
    mounted() {
        AuthService.makeLogout();
    },
    methods: {
    async makeLogin () {
      try {
            AlertService.loading(true,"กำลังเข้าสู่ระบบ");
            const response = await AuthService.makeLogin({ user: this.username, pass: this.password })
            if(response.status == 200){
                await this.$store.dispatch('user/getCurrent')
                await AlertService.loading(false);
                await window.location.replace("/");
                //await this.$router.push('/');
            }else if(response.data.data != undefined && response.data.data.activated == "0"){
                await AlertService.loading(false);
                await this.$router.push('/ini/'+response.data.data.user_id);
            }else{
                await AlertService.error(response.message);
                await AlertService.loading(false);
            }
      } catch (error) {
        AlertService.error(error.status === 404 ? 'User with same user not found' : error.message);
         await AlertService.loading(false);
      }
    }
  }
}
</script>

<style>
  
</style>
